import { AgentModel } from 'common/data/agent/model';
import { DataStore } from 'common/module/data/store';
import { PropertyParamStoreStateInterface } from 'common/module/property/param-store/state.interface';

export class PropertyParamStore extends DataStore {
  /**
   * @inheritDoc
   */
  protected state: PropertyParamStoreStateInterface = {
    pageNumber: 1,
    pageLimit: 20,
    entity: AgentModel.JSONAPI_TYPE,
    entityId: 0,
    filterCategoryId: '',
    sort: '',
  };

  /**
   * @inheritDoc
   */
  public getState(): PropertyParamStoreStateInterface {
    return this.state;
  }

  /**
   * Update params
   */
  public updateParams(params: PropertyParamStoreStateInterface): void {
    this.state = {
      ...this.state,
      ...params,
    };

    this.setState(this.state, this.updateParams);
  }
}
